<div class="alert">
	<i class="icon-info"></i>
	<span>{{ label }}</span>
</div>
